import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    profile: {},
    search: [],
    next: '',
    isBlacklist: false,
    errors: {}
};

getters['fetchProfile'] = function(state) { return state.profile }
getters['fetchSearch'] = function(state) { return state.search }
getters['fetchSearchNext'] = function(state) { return state.next }
getters['fetchIsBlacklist'] = function(state) { return state.isBlacklist }

const actions = {
    get(context, payload) {
        return ApiService
            .get('/profile/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_IS_BLACKLIST', false);
                context.commit('SET_PROFILE', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_IS_BLACKLIST', true);
                    context.commit('SET_PROFILE', {});
                }
                throw new Error('Something goes wrong');
            });
    },
    addToFriends(context, payload) {
        return ApiService
            .get('profile/' + payload + '/add-to-friends/')
            .then((response) => {
                context.commit('SET_ERROR', {});
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    addToBlacklist(context, payload) {
        return ApiService
            .get('profile/' + payload + '/add-to-blacklist/')
            .then((response) => {
                context.commit('SET_ERROR', {});
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    search(context, payload) {
        let url = 'profile/search/?';
        for (let i in payload) {
            url += i + '=' + payload[i] + '&';
        }
        url = url.slice(0, -1);
        return ApiService
            .get(url)
            .then((response) => {
                context.commit('SET_SEARCH', response.data.results);
                context.commit('SET_NEXT', [
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param
                ]);
                context.commit('SET_ERROR', {});
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    searchNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_SEARCH', response.data.results);
                context.commit('SET_NEXT', [
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param
                ]);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    clearSearch(context) {
        context.commit('SET_SEARCH', []);
        context.commit('CLEAR_NEXT');
    },
    updateAvatar(context, payload) {
        context.commit('UPDATE_AVATAR', payload);
    },
    updateVip(context, payload) {
        context.commit('UPDATE_VIP', payload);
    },
    clearProfile(context) {
        context.commit('SET_PROFILE', {})
    },
    setName(context, payload) {
        context.commit('SET_NAME', payload);
    },
    setSearchFriend(context, payload) {
        context.commit('SET_SEARCH_FRIEND', payload);
    }
};

const mutations = {
    SET_PROFILE(state, profile) {
        state.profile = profile;
    },
    UPDATE_AVATAR(state, avatar) {
        state.profile.avatar = avatar;
    },
    UPDATE_VIP(state, vip) {
        state.profile.vip = vip;
    },
    SET_SEARCH(state, search) {
        state.search = search;
    },
    ADD_SEARCH(state, search) {
        state.search = state.search.concat(search);
    },
    SET_NEXT(state, [page, num_pages, url, page_param]) {
        if (page < num_pages) {
            state.next =
            url +
            '&' +
            page_param +
            '=' +
            (page + 1);
        } else {
            state.next = '';
        }
    },
    CLEAR_NEXT(state) {
        state.next = '';
    },
    SET_IS_BLACKLIST(state, isBlacklist) {
        state.isBlacklist = isBlacklist;
    },
    SET_NAME(state, name) {
        state.profile.first_name = name[0];
        state.profile.last_name = name[1];
    },
    SET_SEARCH_FRIEND(state, [id, type]) {
        for (let i in state.search) {
            if (state.search[i].id == id) {
                state.search[i].is_friend.type = type;
            }
        }
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
